export const defaultStyles = {
  margin: {
    marginTop: 16,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
  },
};
